import { object, string } from 'yup';

const addSubscriptionValidationSchema = (isValidEnvironmentName: boolean) =>
  object({
    environmentName: string()
      .required('You must name the new environment.')
      .matches(
        /^[A-Z]{3}$/,
        'Environment names must be 3 capital ASCII alphabet characters.'
      )
      .test({
        name: 'unique',
        exclusive: false,
        params: {},
        message: 'Environment names must be unique.',
        test: (value, context) => {
          if (isValidEnvironmentName) {
            return true;
          }
          return false;
        },
      }),
    selectedApplication: object().required('You must select an application'),
    selectedEnvironment: object().required(
      'You must select an environment type'
    ),
    selectedCidr: string().required('You must select a CIDR block range.'),
  });

export default addSubscriptionValidationSchema;
